var model = BD.Model.extend({})

module.exports = model
